import { render } from "./footerMenu.vue?vue&type=template&id=7fde477e&scoped=true"
import script from "./footerMenu.vue?vue&type=script&lang=js"
export * from "./footerMenu.vue?vue&type=script&lang=js"

import "./footerMenu.vue?vue&type=style&index=0&id=7fde477e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fde477e"]])

export default __exports__